import { useDispatch, useSelector } from 'react-redux';
import EditItem from '../../../../shared/components/IconButtons/EditItem';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';
import { handleUsuarioChange } from '../../../../../store/reducers/usuarioSlice';

const CampoInputConfirmaSenha = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { confirmaSenha } = useSelector(state => state.usuarioState)
    
    const handleChange = (name, value) => {
        dispatch(handleUsuarioChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("senha")
    }

    return (
        <CampoInputTexto
            id="inputConfirmaSenha"
            titulo="Confirma senha*"
            onChange={handleChange}
            name="confirmaSenha"
            value={confirmaSenha}
            label="obrigatório"
            type="password"
            required={true}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputConfirmaSenha
